(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["revok-header"]) return;
  try {
    
document.querySelector('.menu-toggle')?.addEventListener('click',function(){const open=this.getAttribute('aria-expanded')!=='true';this.setAttribute('aria-expanded',String(open));document.getElementById('main-nav')?.classList.toggle('open',open)});
document.querySelector('[data-search-toggle]')?.addEventListener('click',function(e){e.preventDefault();const el=document.getElementById('search');const open=el.hidden;el.hidden=!open;this.setAttribute('aria-expanded',String(open));if(open)el.querySelector('input[type="search"]')?.focus()});
const rooms=Array.from(document.querySelectorAll('[data-screening-room]'));
function showTrailer(room,choice,play){if(!room||!choice)throw new Error('Trailer not found');const id=choice.dataset.video;if(!/^[A-Za-z0-9_-]{11}$/.test(id))throw new Error('Invalid video');room.querySelectorAll('[data-trailer]').forEach(button=>{const selected=button===choice;button.classList.toggle('active',selected);button.setAttribute('aria-pressed',String(selected))});room.querySelector('[data-playing-title]').textContent=choice.dataset.title;room.querySelector('[data-playing-meta]').textContent=choice.dataset.meta;room.querySelector('[data-youtube-fallback]').href='https://www.youtube.com/watch?v='+id;const productLink=room.querySelector('[data-trailer-product]');if(productLink){const url=choice.dataset.productUrl;productLink.hidden=!url;if(url){productLink.href=url;productLink.setAttribute('aria-label',productLink.dataset.label+': '+choice.dataset.productTitle)}else{productLink.removeAttribute('href');productLink.removeAttribute('aria-label')}}const player=room.querySelector('[data-player]');if(play){const iframe=document.createElement('iframe');iframe.src='https://www.youtube-nocookie.com/embed/'+id+'?autoplay=1&playsinline=1&rel=0';iframe.title=choice.dataset.title+' trailer — REVOK';iframe.allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';iframe.allowFullscreen=true;iframe.referrerPolicy='strict-origin-when-cross-origin';player.replaceChildren(iframe)}return{id,title:choice.dataset.title,playbackRequested:play}}
const preparedThumbnails=new WeakSet();
function prepareYouTubeThumbnail(image){const id=image.dataset.youtubeThumbnail;if(!/^[A-Za-z0-9_-]{11}$/.test(id)||preparedThumbnails.has(image))return;preparedThumbnails.add(image);const sizes=['maxresdefault','sddefault','hqdefault'];let step=0;const fallback=()=>{if(step>=sizes.length-1){image.hidden=true;return}step+=1;image.src='https://i.ytimg.com/vi/'+id+'/'+sizes[step]+'.jpg'};image.addEventListener('error',fallback);image.addEventListener('load',()=>{if(image.naturalWidth<320)fallback()});if(image.complete&&image.naturalWidth<320)fallback()}
function prepareScreeningThumbnails(root){root.querySelectorAll('[data-youtube-thumbnail]').forEach(prepareYouTubeThumbnail)}
prepareScreeningThumbnails(document);
document.addEventListener('shopify:section:load',event=>prepareScreeningThumbnails(event.target));
document.addEventListener('click',event=>{const choice=event.target.closest('[data-trailer]');if(choice){showTrailer(choice.closest('[data-screening-room]'),choice,true);return}const play=event.target.closest('[data-play-trailer]');if(play){const room=play.closest('[data-screening-room]');showTrailer(room,room.querySelector('[data-trailer].active')||room.querySelector('[data-trailer]'),true)}});
const lifecycle=new AbortController();
if(document.modelContext?.registerTool&&rooms.length){const tools=[{name:'get_revok_trailers',description:'List the REVOK screening-room trailers and the selected trailer.',inputSchema:{type:'object',properties:{},additionalProperties:false},annotations:{readOnlyHint:true,untrustedContentHint:false},execute:()=>({trailers:Array.from(document.querySelector('[data-screening-room]').querySelectorAll('[data-trailer]')).map(b=>({id:b.dataset.video,title:b.dataset.title,selected:b.getAttribute('aria-pressed')==='true'}))})},{name:'play_revok_trailer',description:'Select a REVOK trailer and load its YouTube player in the visible screening room. Playback may require a browser play action.',inputSchema:{type:'object',properties:{videoId:{type:'string'}},required:['videoId'],additionalProperties:false},annotations:{readOnlyHint:false,untrustedContentHint:false},execute:input=>{if(!input||typeof input.videoId!=='string'||Object.keys(input).some(k=>k!=='videoId'))throw new Error('Provide one videoId from get_revok_trailers');const choice=Array.from(document.querySelector('[data-screening-room]').querySelectorAll('[data-trailer]')).find(b=>b.dataset.video===input.videoId);if(!choice)throw new Error('Trailer is not in this screening room');const result=showTrailer(document.querySelector('[data-screening-room]'),choice,true);document.querySelector('[data-screening-room]').scrollIntoView({block:'center'});return result}}];for(const tool of tools){try{Promise.resolve(document.modelContext.registerTool(tool,{signal:lifecycle.signal})).catch(()=>{})}catch{}}window.addEventListener('pagehide',()=>lifecycle.abort(),{once:true})}
document.querySelectorAll('[data-sort]').forEach(select=>select.addEventListener('change',()=>{const url=new URL(location.href);url.searchParams.set('sort_by',select.value);url.searchParams.delete('page');location.href=url.toString()}));
document.querySelectorAll('[data-gallery-thumb]').forEach(button=>button.addEventListener('click',()=>{const image=document.querySelector('[data-gallery-main]');if(!image)return;image.src=button.dataset.image;image.removeAttribute('srcset');image.alt=button.dataset.alt||'';document.querySelectorAll('[data-gallery-thumb]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)))}));
document.querySelector('[data-variant-select]')?.addEventListener('change',function(){const option=this.selectedOptions[0],form=this.closest('form'),button=form.querySelector('[data-add-button]');document.querySelector('[data-product-price]').textContent=option.dataset.price;button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?button.dataset.soldLabel:button.dataset.addLabel;const url=new URL(location.href);url.searchParams.set('variant',this.value);history.replaceState({},'',url);document.querySelector('[data-stock-text]').textContent=button.disabled?button.dataset.soldLabel:document.querySelector('[data-stock-text]').dataset.availableLabel});

document.querySelectorAll('[data-category-nav]').forEach(select=>{const current=new URL(location.href);for(const option of select.options){const target=new URL(option.value,location.origin);if(target.pathname===current.pathname&&target.search===current.search)select.value=option.value}select.addEventListener('change',()=>{if(select.value)location.assign(select.value)})});

const preparedCommunityVideos=new WeakSet();
function prepareCommunityVideos(root){root.querySelectorAll('.community-video').forEach(video=>{
  if(preparedCommunityVideos.has(video))return;
  preparedCommunityVideos.add(video);
  video.muted=true;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches||navigator.connection?.saveData||!('IntersectionObserver' in window))return;
  let started=false;
  const observer=new IntersectionObserver(entries=>{for(const entry of entries){
    if(!video.isConnected){observer.disconnect();return}
    if(entry.isIntersecting&&!started){started=true;video.play()?.catch(()=>{})}
    else if(!entry.isIntersecting&&!video.paused)video.pause();
  }},{threshold:.15});
  observer.observe(video);
})}
prepareCommunityVideos(document);
document.addEventListener('shopify:section:load',event=>prepareCommunityVideos(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["revok-screening"] && !Shopify.designMode) return;
  try {
    
(() => {
  const screeningLibraries = new WeakMap();
  function shuffleTrailers(items) {
    const result = [...items];
    for (let i = result.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [result[i], result[j]] = [result[j], result[i]];
    }
    return result;
  }
  function chooseTrailers(library, selectedOnly, previous, editor) {
    const seen = new Set();
    const unique = library.filter(item => {
      if (!/^[A-Za-z0-9_-]{11}$/.test(item.dataset.video)) return false;
      if (selectedOnly && item.dataset.alwaysInclude !== 'true') return false;
      if (seen.has(item.dataset.video)) return false;
      seen.add(item.dataset.video);
      return true;
    });
    const pinned = unique.filter(item => item.dataset.alwaysInclude === 'true').slice(0, 7);
    const others = unique.filter(item => item.dataset.alwaysInclude !== 'true');
    const fresh = others.filter(item => !previous.includes(item.dataset.video));
    const repeats = others.filter(item => previous.includes(item.dataset.video));
    const remainder = editor ? others : [...shuffleTrailers(fresh), ...shuffleTrailers(repeats)];
    let chosen = [...pinned, ...remainder.slice(0, 7 - pinned.length)];
    if (!editor) {
      chosen = shuffleTrailers(chosen);
      if (chosen.length > 1 && chosen[0].dataset.video === previous[0]) chosen.push(chosen.shift());
    }
    return chosen;
  }
  function thumbnailFallback(image, videoId) {
    image.removeAttribute('data-youtube-thumbnail');
    if (!videoId) return;
    const sizes = ['maxresdefault', 'sddefault', 'hqdefault'];
    let step = 0;
    const next = () => {
      if (step === sizes.length - 1) { image.hidden = true; return; }
      image.src = 'https://i.ytimg.com/vi/' + videoId + '/' + sizes[++step] + '.jpg';
    };
    image.addEventListener('error', next);
    image.addEventListener('load', () => { if (image.naturalWidth < 320) next(); });
    if (image.complete && image.naturalWidth < 320) next();
  }
  function renderTrailerLineup(room, chosen, state) {
    const playlist = room.querySelector('.playlist');
    const buttons = chosen.map((item, index) => {
      const button = item.cloneNode(true);
      button.classList.toggle('active', index === 0);
      button.setAttribute('aria-pressed', String(index === 0));
      return button;
    });
    playlist.replaceChildren(...buttons);
    if (!buttons.length) return;
    const first = buttons[0];
    const productLink=room.querySelector('[data-trailer-product]');if(productLink){const url=first.dataset.productUrl;productLink.hidden=!url;if(url){productLink.href=url;productLink.setAttribute('aria-label',productLink.dataset.label+': '+first.dataset.productTitle)}else{productLink.removeAttribute('href');productLink.removeAttribute('aria-label')}}
    const player = room.querySelector('[data-player]');
    player.replaceChildren(...Array.from(state.player.childNodes, node => node.cloneNode(true)));
    const poster = player.querySelector('img');
    poster.removeAttribute('srcset');
    poster.removeAttribute('sizes');
    poster.hidden = false;
    poster.src = first.dataset.thumb;
    thumbnailFallback(poster, first.dataset.thumbAuto);
    player.querySelector('[data-play-trailer]').setAttribute('aria-label', room.dataset.playLabel + ': ' + first.dataset.title);
    room.querySelector('[data-playing-title]').textContent = first.dataset.title;
    room.querySelector('[data-playing-meta]').textContent = first.dataset.meta;
    room.querySelector('[data-youtube-fallback]').href = 'https://www.youtube.com/watch?v=' + first.dataset.video;
    buttons.forEach(button => thumbnailFallback(button.querySelector('img'), button.dataset.thumbAuto));
  }
  function initializeScreening(room, revisit = false) {
    if (screeningLibraries.has(room) && !revisit) return;
    let state = screeningLibraries.get(room);
    if (!state) {
      const library = room.querySelector('[data-trailer-library]');
      if (!library) return;
      state = { library: Array.from(library.content.querySelectorAll('[data-trailer]')), player: room.querySelector('[data-player]').cloneNode(true) };
      screeningLibraries.set(room, state);
    }
    const editor = room.dataset.designMode === 'true';
    const key = 'revok-screening-previous-' + room.dataset.sectionId;
    let previous = [];
    if (!editor) { try { const stored = JSON.parse(sessionStorage.getItem(key) || '[]'); if (Array.isArray(stored)) previous = stored; } catch {} }
    const chosen = chooseTrailers(state.library, room.dataset.selectedOnly === 'true', previous, editor);
    renderTrailerLineup(room, chosen, state);
    if (!editor) { try { sessionStorage.setItem(key, JSON.stringify(chosen.map(item => item.dataset.video))); } catch {} }
  }
  document.querySelectorAll('[data-screening-room]').forEach(room => initializeScreening(room));
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-screening-room]').forEach(room => initializeScreening(room)));
  window.addEventListener('pageshow', event => { if (event.persisted) document.querySelectorAll('[data-screening-room]').forEach(room => initializeScreening(room, true)); });
  document.addEventListener('shopify:block:select', event => {
    const room = event.target.closest('[data-screening-room]') || event.target.querySelector('[data-screening-room]') || document.querySelector('[data-screening-room][data-design-mode="true"]');
    const state = room && screeningLibraries.get(room);
    if (!state || room.dataset.designMode !== 'true') return;
    const selected = state.library.find(item => item.dataset.blockId === event.detail.blockId);
    if (!selected) return;
    const others = Array.from(room.querySelectorAll('.playlist [data-trailer]')).filter(item => item.dataset.video !== selected.dataset.video).slice(0, 6);
    renderTrailerLineup(room, [selected, ...others], state);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
